import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=5a1bc168"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=5a1bc168&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports